import ApiClient from './ApiClient';

export const buildParams = (page, sortAttr = 'id', search = '', limit = 15) => {
  let params = `page=${page}&limit=${limit}&sort=${sortAttr}`;

  if (search) {
    params = `${params}&q=${search}`;
  }

  return params;
};

class WebhooksSendMessage extends ApiClient {
  constructor() {
    super('webhooks_send_messages', { accountScoped: true });
  }

  get(page, sortAttr, limit) {
    let requestURL = `${this.url}?${buildParams(
      page,
      sortAttr,
      null,
      limit
    )}`;

    return axios.get(requestURL);
  }

  search(page, sortAttr, search) {
    let requestURL = `${this.url}/search?${buildParams(
      page,
      sortAttr,
      search
    )}`;

    return axios.get(requestURL);
  }
}

export default new WebhooksSendMessage();
